import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "list-item__button" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = {
  key: 1,
  class: "no-data-message"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { t } from '@/i18n'
import { IUser } from '@/api/AuthApi/types'
import { MutationTypes } from '@/store/container/mutation-types'
import UserApi from '@/api/UserApi'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import Select from '@/components/Select/Select.vue'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const loading = ref(true)
const currentUser = ref<IUser | null>(null)
const selectedCompany = ref<string>('')
const selectedOrderType = ref<string>('')
const availableOrderTypes = ref<string[]>([])

const userCompanies = computed(() =>
  currentUser.value?.companies
    .filter(company => company.company_type == 'industry')
    .map(company => ({
      label: company.name as unknown as string,
      value: company.uuid as unknown as string,
    })),
)

const handleCompanySelect = (value: string) => {
  selectedOrderType.value = ''
  selectedCompany.value = value
  getAvailableOrderTypes(value)
}

const getAvailableOrderTypes = (companyUuid: string) => {
  const userCompany = currentUser.value?.companies.find(
    company => company.uuid == companyUuid,
  )
  if (userCompany?.settings?.available_order_types_for_binity_order_app) {
    availableOrderTypes.value = userCompany?.settings
      ?.available_order_types_for_binity_order_app as unknown[] as string[]
  }
  if (availableOrderTypes.value?.length == 1) {
    selectedOrderType.value = availableOrderTypes.value[0]
  }
}

const fetchUserData = async () => {
  currentUser.value = await UserApi.getUser()
  if (currentUser.value?.companies?.length == 1) {
    selectedCompany.value = currentUser.value.companies[0].uuid as string
  }
}

const createNewOrder = (orderType: string) => {
  router.push({
    name: 'NewOrder',
    query: {
      type: orderType,
      companyUuid: selectedCompany.value,
    },
  })
}

watch(
  () => selectedCompany.value,
  companyUuid => {
    if (companyUuid) {
      getAvailableOrderTypes(companyUuid)
    }
  },
)

onMounted(async () => {
  store.commit(MutationTypes.CLEAR_STATE)
  await fetchUserData()
  loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('meta.company')), 1),
        _createVNode(Select, {
          modelValue: selectedCompany.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((selectedCompany).value = $event)),
            handleCompanySelect
          ],
          options: _unref(userCompanies)
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('company.availableOrderTypes')), 1),
        (availableOrderTypes.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableOrderTypes.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item,
                    class: _normalizeClass(["list-item", {
            'list-item--selected': item === selectedOrderType.value,
          }])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("label", {
                        class: "list-item__title",
                        for: item
                      }, _toDisplayString(_ctx.$t(`availableOrderTypes.${item}`)), 9, _hoisted_5),
                      _withDirectives(_createElementVNode("input", {
                        id: item,
                        class: "list-item__control",
                        type: "radio",
                        name: "order-type",
                        value: item,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOrderType).value = $event))
                      }, null, 8, _hoisted_6), [
                        [_vModelRadio, selectedOrderType.value]
                      ])
                    ])
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("a", {
                class: _normalizeClass(["button button--cta-primary", { 'button--disabled': !selectedOrderType.value }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (createNewOrder(selectedOrderType.value)))
              }, _toDisplayString(_ctx.$t('meta.next')), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(selectedCompany.value
          ? _unref(t)('company.noOrderTypesAvailable')
          : _unref(t)('company.notSelected')), 1))
      ]))
}
}

})